export * from '@macs-frontend/web/core/base/app.base-component';
